// The scope every waitlist route but reinstate requires; reinstate has its own.
export const WAITLIST_ACTION_SCOPE = 'affordable-waitlist-add-remove-select';

// Reinstate is scoped on its own, both on the route and on the summary card.
export const REINSTATE_SCOPE = 'affordable-waitlist-reinstate';

export const denyReasons = [
  'Income Ineligible',
  'Criminal Background',
  'Eviction History',
  'False Information on Application',
  'Housing History',
  'Outstanding Debt',
  'Other - See Notes',
];

export const cancelReasons = [
  'No Longer Interested',
  'Duplicate',
  'Found Other Housing',
  'No Response',
  'Other - See Notes',
];
